'use server'

import { apiRequest, ApiResponse } from '../request'

/** Saldo de créditos de IA da organização. Créditos em unidade, com fração. */
export interface AiCreditBalance {
    /** Créditos ligados: o valor do crédito está configurado na plataforma. */
    enabled: boolean
    /** Conta da plataforma: não compra pacote nem entra nos créditos. */
    platformAccount: boolean
    /** Créditos por mês do plano; `null` quando o plano não usa créditos. */
    planCredits: number | 'unlimited' | null
    totalCredits: number
    plan: { remainingCredits: number; grantedCredits: number; expiresAt: string } | null
    purchased: Array<{ remainingCredits: number; grantedCredits: number; expiresAt: string }>
    monthUsage: Array<{ feature: string; credits: number }>
}

export async function getAiCreditBalance(): Promise<ApiResponse<AiCreditBalance>> {
    return apiRequest<AiCreditBalance>('ai-credits/balance', {})
}

/** Créditos para exibir: inteiro quando não há fração relevante. */
export function formatCredits(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
        maximumFractionDigits: value < 10 ? 2 : 0,
    }).format(value)
}

/** O saldo merece aparecer: plano com créditos ou crédito comprado. */
export function hasCreditBalanceToShow(balance: AiCreditBalance | null): balance is AiCreditBalance {
    if (!balance || !balance.enabled) return false
    return balance.planCredits !== null || balance.totalCredits > 0
}
